module.exports = __webpack_public_path__ + "static/media/16UNODC26.ea0fa027.jpg";